<template>
  <StepLayout pageId="page-4" title="Booking Details" contentId="orderDetial-mod" contentClass="orderDetial-mod">
    <ul class="order-details">
      <li class="name-col">
        <div class="col-label">Name:</div>
        <strong id="orderName">
          <span id="orderFirstName">{{ infoForm.firstName }}</span>&nbsp;<span id="orderLastName">{{ infoForm.surname
            }}</span>
        </strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="email-col">
        <div class="col-label">Email:</div>
        <strong id="orderEmail">{{ infoForm.email }}</strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="phone-col">
        <div class="col-label">Phone Number:</div>
        <strong id="orderPhone">
          <span v-show="infoForm.areaCode !== '' || infoForm.areaCode !== ' '">{{ infoForm.areaCode }} </span>
          {{ infoForm.phone }}
        </strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="phone-col">
        <div class="col-label">Party Size:</div>
        <strong id="orderPeople">{{ currentSize }} people</strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="date-col">
        <div class="col-label">Date:</div>
        <strong id="orderDate">{{ currentDate }}</strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="time-col">
        <div class="col-label">Time:</div>
        <strong id="orderTime">{{ currentTime }}</strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="time-col">
        <div class="col-label">Deposit:</div>
        <strong id="orderDeposit">&pound; {{ depositPrice }}</strong>
      </li>
    </ul>
    <div class="readTermRadioCol">
      <a-checkbox :checked="accepted" @change="readNot">
        <span class="radio-text">
          <span>I have read and agree to the</span>
          <a id="modalLink" @click.stop="termsAndConditions" href="javascript:void(0)" data-target="#modal-ajax"
            data-toggle="modal">Booking Terms and Conditions</a><span>.</span>
        </span>
      </a-checkbox>
    </div>
    <div class="otherCheckboxCol">
      <label class="p">I want to receive updates and offers from {{ storeName }}</label>
      <div class="type-grid">
        <div class="checkbox checkbox-info">
          <input id="fromStore_type-email" type="checkbox" value="1" :checked="sendEmail === 1" @click="setSendEmail" />
          <label for="fromStore_type-email">Email</label>
        </div>
        <!-- <div class="checkbox checkbox-info">
          <input id="fromStore_type-sms" type="checkbox" value="1" :checked="sendSms === 1" @click="setSendSms" />
          <label for="fromStore_type-sms">SMS</label>
        </div> -->
      </div>
    </div>
  </StepLayout>
</template>
<script>
import StepLayout from "./StepLayout.vue";

export default {
  name: "ReservationStep4",
  components: {
    StepLayout
  },
  props: {
    infoForm: Object,
    depositPrice: [String, Number],
    currentSize: [String, Number],
    currentDate: String,
    week: String,
    currentTime: String,
    storeName: String,
    accepted: Boolean,
    sendEmail: Number,
    sendSms: Number
  },
  methods: {
    readNot(e) { this.$emit("readNot", e.target.checked); },
    termsAndConditions() { this.$emit("termsAndConditions"); },
    setSendEmail() { this.$emit("setSendEmail"); },
    setSendSms() { this.$emit("setSendSms"); }
  }
};
</script>

<style lang="scss">
.readTermRadioCol {
  text-align: left;
  .ant-checkbox-wrapper {
    display: flex;
    align-items: flex-start;
  }
  .ant-checkbox {
    flex-shrink: 0;
    margin-top: 4px;
  }
  .radio-text {
    display: inline;
    line-height: 1.5;
    a {
      white-space: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReservationStep4.vue